import(/* webpackMode: "eager" */ "/vercel/path0/frontend/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["AnalyticsLoader"] */ "/vercel/path0/frontend/components/analytics-loader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CookieBanner"] */ "/vercel/path0/frontend/components/cookie-banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/vercel/path0/frontend/components/theme-provider.tsx");
